<template>
  <Modal ref="modal" v-model:open="open" width="400px" size="fixed" :title="t('invite_users')" :btn-to-close="false">
    <div class="flex items-end gap-3">
      <InputText
        v-model="invitation.email"
        class="w-full"
        :label="t('settings.users.invite_with_mail')"
        :placeholder="t('settings.users.invite_placeholder')"
      />
      <Dropdown v-model="invitation.role" :options="roles" item-max-width="420px" />
    </div>
    <template #footer>
      <ModalFooter
        :disabled="!isEmailValid"
        :loading="creating"
        :confirm-text="t('settings.users.send_invitation')"
        @confirm="createUser"
        @cancel="handleClose"
      />
    </template>
  </Modal>
</template>

<script setup lang="ts">
  // Composables & Services
  const { t } = useI18n();
  const { roles } = useCapabilities();

  // State
  const open = ref(false);
  const creating = ref(false);
  const invitation = ref({
    email: "",
    role: "3",
  });

  // Computed
  const isEmailValid = computed(() => {
    if (!invitation.value.email) return false;
    return !!invitation.value.email.match(/^[\w-.+]+@([\w-]+\.)+[\w-]{2,}$/);
  });

  // Methods
  const resetInvitation = () => {
    invitation.value.email = "";
    invitation.value.role = "3";
  };

  const createUser = () => {
    dialogConfirm({
      message: t("settings.users.confirm_invitation", {
        user: invitation.value.email,
        role: roles.value.find((r) => r.value == invitation.value.role)?.label,
      }),
      onConfirm: async () => {
        creating.value = true;

        try {
          await homeFetch("workspace/users", {
            method: "POST",
            body: {
              emails: [invitation.value.email],
              roles: [invitation.value.role],
            },
          });

          toastAdd({
            text: t("settings.users.invitation.success", {
              user: invitation.value.email,
              role: roles.value.find((r) => r.value == invitation.value.role)?.label,
            }),
          });

          resetInvitation();
        } finally {
          creating.value = false;
        }
      },
    });
  };

  // Event Bus Handlers
  const handleToggle = () => (open.value = !open.value);
  const handleOpen = () => (open.value = true);
  const handleClose = () => {
    open.value = false;
    resetInvitation();
  };

  // Lifecycle Hooks
  onMounted(() => {
    EventBus.$on("INVITEUSERS_TOGGLE", handleToggle);
    EventBus.$on("INVITEUSERS_OPEN", handleOpen);
    EventBus.$on("INVITEUSERS_CLOSE", handleClose);
  });

  onUnmounted(() => {
    EventBus.$off("INVITEUSERS_TOGGLE", handleToggle);
    EventBus.$off("INVITEUSERS_OPEN", handleOpen);
    EventBus.$off("INVITEUSERS_CLOSE", handleClose);
  });
</script>
